export default {
    title: 'Customize logo',
    submit: 'Save',
    delete: 'Delete',
    deleteLogo: {
        title: 'Delete logo',
        notice: 'Are you sure?',
        confirm: 'Yes, delete now',
        cancel: 'Cancel'
    }
}
